import { EyeClosedIcon, FilterIcon, GearIcon, ServerIcon, SortAscIcon, SortDescIcon } from '@primer/octicons-react';

/** Map Octicons icon. */
const octiconsMap = {
  outline: {
    gear: GearIcon,
    sortAsc: SortAscIcon,
    sortDesc: SortDescIcon,
    filter: FilterIcon,
    eyeClosed: EyeClosedIcon,
    server: ServerIcon,
  },

  fill: {},
};

export default octiconsMap;
